import { vesselJobsQueries } from '@/modules/PMS/api/vessel-jobs/queries';
import { useQuery } from '@tanstack/react-query';

interface UseApprovalsPendingCountOptions {
  enabled?: boolean;
}

export const useApprovalsPendingCount = (options?: UseApprovalsPendingCountOptions) => {
  const { data: pendingCount = 0 } = useQuery({
    // Same query key as useApprovalsData (no criteria) — shares cache with the table.
    // When the Approvals table refetches for any reason, this badge updates automatically.
    // When off the Approvals page, polls every 60s + refetches on window focus.
    ...vesselJobsQueries.approvalsDashboard(),
    select: (items) => items.filter((item) => item.Status === 'Pending').length,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
    enabled: options?.enabled ?? true
  });

  return { pendingCount };
};
